/**
 * Portal Manta · LinhaTabelaKPI
 * Extraído de App.jsx (v29 modular)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { M, F, STATUS } from '../../tokens/theme.js';
import { CelulaEdit } from './CelulaEdit.jsx';
import { FonteKpiBadge } from './FonteKpiBadge.jsx';

const LinhaTabelaKPI = memo(function LinhaTabelaKPI_Inner({campo, idx, valor, fonte, onChange, onLimpar, tdStl}){
  const preenchido = valor !== undefined && valor !== null && valor !== '' && valor !== 0;
  return (<tr style={{
    background: idx % 2 === 0 ? '#fff' : '#FAFBFC',
  }}>
    <td style={{...tdStl, textAlign:'center', fontFamily:F.mono, fontSize:10, color:M.muted, width:36}}>
      {idx + 1}
    </td>
    <td style={{...tdStl, textAlign:'center', fontFamily:F.mono, fontSize:10.5, color:M.muted, fontWeight:600}}>
      {campo.blocoLabel}
    </td>
    <td style={{...tdStl}}>
      {campo.label}
    </td>
    <td style={{...tdStl, textAlign:'center', fontFamily:F.mono, fontSize:10, color:M.muted}}>
      {campo.sufixo || '—'}
    </td>
    <td style={{...tdStl, padding:'1px 4px', minWidth:160}}>
      <CelulaEdit campo={campo} valor={valor} onChange={v => onChange(campo.k, v, 'manual')}/>
    </td>
    <td style={{...tdStl, textAlign:'center'}}>
      <FonteKpiBadge fonte={fonte}/>
    </td>
    <td style={{...tdStl, textAlign:'center', padding:0}}>
      {preenchido && (<button onClick={()=>onLimpar(campo.k)} title="Limpar valor" style={{
        width:24, height:22, padding:0, border:'none', background:'transparent',
        cursor:'pointer', color:'#9CA3AF', fontSize:12, lineHeight:1,
      }}>↻</button>)}
    </td>
  </tr>);
});

export { LinhaTabelaKPI };
export default LinhaTabelaKPI;
